import { i18n } from '@lt/localization';
import { API_KEY } from './constants';
import loadMapModules from './loaders/moduleLoaders';

// Инициируем загрузку модулей для Яндекс Карт
export const loadModulePromise = loadMapModules(
  {
    version: 3,
    apiKey: API_KEY,
    lang: i18n.t('map.localization_code'),
  },
  ['clusterer', 'markers', 'controls'],
);
